import React from 'react'
import PropTypes from 'prop-types'

import { DocumentFile } from '../../../entities/DocumentFile'

import { Hide } from '../Hide'
import { Regulation } from '../../chamber/About/AboutUs/RegulationsSection/Regulation/Regulation'

import './DocumentList.css'

const DocumentList = ({ documents = [], dark = false }) => {
    return (
        <Hide ifEmpty={documents}>
            <div className="documentation-section__documents">
                {documents.map(document => (
                    <Regulation regulation={document} key={document.title} dark={dark} />
                ))}
            </div>
        </Hide>
    )
}

DocumentList.propTypes = {
    section: PropTypes.arrayOf(PropTypes.instanceOf(DocumentFile)),
    dark: PropTypes.bool
}

export { DocumentList }
